import React from '../services/React';
import ErrorMessage from './ErrorMessage';

function AuthErrorMessage() {
  return (
    <ErrorMessage
      title="Authentication failed"
      message="The backend could not authenticate the incoming request."
    />
  );
}

export default AuthErrorMessage;



// WEBPACK FOOTER //
// ./src/commons/components/AuthErrorMessage.jsx